<template>
	<div>
		<v-icon small color="yellow darken-1" v-for="i in full" :key="'full'+i">mdi-star</v-icon>
		<v-icon small color="yellow darken-1" v-if="!half">mdi-star-half-full</v-icon>
		<v-icon small color="yellow darken-1" v-for="i in empty" :key="'half'+i">mdi-star-outline</v-icon>
	</div>
</template>

<script>
export default {
	props: {
		rating: String
	},
	data() {
		return {
			star: 3.4
		}
	},
	computed: {
		full() {
			return parseInt(this.rating)
		},
		half() {
			return Number.isInteger(parseFloat(this.rating))
		},
		empty() {
			let star = 5 - parseInt(this.rating)
			if (star && !this.half) {
				star = 5 - parseInt(this.rating) - 1
			}
			return star
		}
	}
}
</script>